import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface NgLetContext {
    $implicit: any;
    ngLet: any;
}

@Directive({
    selector: '[ngLet]',
    standalone: false
})
export class NgLetDirective {
    private context: NgLetContext = { ngLet: null, $implicit: null };
    private hasView = false;

    @Input()
    set ngLet(value: any) {
        this.context.$implicit = this.context.ngLet = value;
        if (!this.hasView) {
            this.hasView = true;
            this.viewContainerRef.createEmbeddedView(this.templateRef, this.context);
        }
    }

    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<NgLetContext>
    ) {}
}
